
        <div class="wo-dialog-alert__body">
            {{message}}
        </div>
        <div class="wo-dialog-alert__buttons">
            <a class="btn btn-primary" href="javascript:void(0);" (click)="close()">OK</a>
        </div>
    